<button class="btn btn-sm btn-secondary" (click)="export()" title="Export to Pdf">
    <fa-icon [icon]="faFilePdf" [fixedWidth]="true"></fa-icon>
</button>
